<template>
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 12H32M0 20H32"
      stroke="var(--icon-border-default)"
      stroke-width="1.6"
    />
  </svg>
</template>
